import {ssrSafeDocument} from '@github-ui/ssr-utils'

type DataRouterMatch = {
  route?: {id?: string}
  staticData?: {dataRouterId?: string}
}

type DataRouterReactApp = HTMLElement & {
  routerOrHistory?: {state?: {matches?: DataRouterMatch[]}}
}

const ROUTE_ID_META_SELECTOR = 'meta[name="data-router-route-id"]'

export function getCurrentReactAppName() {
  const injectedAppName = ssrSafeDocument?.querySelector('meta[name="react-app-name"]')?.getAttribute('content')

  if (injectedAppName) return injectedAppName

  // special case for memex
  if (ssrSafeDocument?.querySelector('projects-v2')) return 'memex'
  // special case for repos-overview that is a partial
  if (ssrSafeDocument?.querySelector('react-partial[partial-name="repos-overview"]')) return 'repos-overview'

  return ssrSafeDocument?.querySelector('react-app')?.getAttribute('app-name')
}

export function getCurrentRouteId(): string | undefined {
  const reactApp = ssrSafeDocument?.querySelector<DataRouterReactApp>('react-app[data-data-router-enabled="true"]')
  const matches = reactApp?.routerOrHistory?.state?.matches

  if (Array.isArray(matches)) {
    for (let index = matches.length - 1; index >= 0; index--) {
      const match = matches[index]
      const routeId = match?.staticData?.dataRouterId ?? match?.route?.id
      if (routeId) return routeId
    }
  }

  return ssrSafeDocument?.querySelector<HTMLMetaElement>(ROUTE_ID_META_SELECTOR)?.content || undefined
}
